import { defineComponent as _defineComponent } from 'vue'
import type { GetPopularTitlesQueryVariables } from '@/pages/graphql/queries/GetPopularTitles.query';

import { ModalHelper } from '@/helpers/modal-helper';

import { useReelsExp } from './query';
import ReelModal from '@/components/experiments/ReelsExp/components/ReelModal.vue';
import ReelsExp from '../index';

import { computed } from 'vue';
import { faPlay } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReelModalSwitch',
  props: {
    queryVariables: null
  },
  setup(__props: any) {

const props = __props as {
	queryVariables: GetPopularTitlesQueryVariables;
};



const { activeReelExpVariant } = useReelsExp();
const activateVariant = computed(() => activeReelExpVariant.value === 'variant_2');

function handleClick() {
	ReelsExp.trackEvent({
		action: 'click',
		label: 'video_player_open',
		property: 'shorts_popular',
	});
	openModal();
}

function openModal() {
	ReelsExp.trackEvent({
		action: 'impression',
		property: 'shorts_popular',
	});

	ModalHelper.openModal(
		ReelModal,
		{
			queryVariables: props.queryVariables,
			title: '',
		},
		{ cssClass: 'reel-modal' }
	);
}

return { __sfc: true,props, activeReelExpVariant, activateVariant, handleClick, openModal, faPlay }
}

})